import React, { useState } from "react";
import { RoundShape } from "../Assets";
import { PiPlusBold } from "react-icons/pi";
import { Modal } from "react-bootstrap";
import blogImg from "../Assets/npm.png"

const BlogPage = () => {
  const [show, setShow] = useState(false);

  const storyArray = [
    {
      id: 1,
      img: blogImg,
      date: "April 3, 2026",
      storyTopic: "The Hidden Danger in Your node_modules: A Survey of npm Supply Chain Attacks",
      storyContentShort:
        "In the modern development landscape, we aren't just writing code; we are assembling it from millions of existing building blocks...",
      storyContent: `In the modern development landscape, we aren't just writing code; we are assembling it from millions of existing building blocks. While this speed is a superpower, it has also opened a massive door for cybercriminals. The world is currently experiencing a surge in supply chain attacks that target the very foundation of our software: the npm ecosystem.

Why Is the World Seeing So Many Attacks?

The sheer scale of the npm ecosystem makes it an attractive target. There are currently over 2 million packages available, and the average modern application depends on more than 1,000 indirect (transitive) dependencies. This means that when you install one library, you are often silently trusting hundreds of others you haven't even heard of.

Attackers exploit several key vulnerabilities in this chain:

Speed Over Security: A developer can publish a npm package in just minutes, often with limited or no security verification.
Deep Dependency Chains: Most risks are hidden deep within transitive dependencies that developers rarely review.
The AI "Slop" Factor: A new trend called "Slopsquatting" has emerged. Attackers monitor the "slop" (low-quality or hallucinated output) from Generative AI tools. When AI suggests a package name that doesn't actually exist, attackers quickly register that name to catch developers who copy-paste the AI's mistake.

A Survey of the Threat: The PhantomRaven Campaign

To understand the frequency of these attacks, we can look at the PhantomRaven campaign. This is a sophisticated supply chain attack specifically designed to target developers and organizations by distributing malware through malicious packages.

Recent surveys of this threat highlight its growing reach:
88 New Malicious Packages: Researchers at Endor Labs recently uncovered 88 new packages tied to a single new wave of this campaign.
Silent Compromise: These attacks don't wait for you to run your code. The malicious scripts are designed to execute during the installation phase itself. Just running npm install is enough to compromise a system.
Data Harvested: These attacks are highly effective at stealing sensitive information, including CI/CD tokens, credentials, .gitconfig files, and environment variables. They even profile your system by gathering your IP address, OS details, and Node.js version.

How to Protect Your Project:

Awareness is only the first step. To prevent these attacks, you must move away from "blind trust" and adopt a policy of active verification.

Verify Before You Install: Always check for typosquatting. Attackers often use names like lodahs (instead of lodash) or expres (instead of express) to trick hurried developers.
Audit Your AI: Never blindly copy dependency suggestions from AI tools without verifying the package is legitimate.
Use Security Tooling: Regularly audit your project using tools like Snyk, Socket.dev, or Dependabot.
Lock Your Versions: Use package-lock.json and avoid blindly installing the "latest" versions of packages without review.

We often worry about one big vulnerable system being our greatest threat, but in reality, the bigger risk is the many small, "trusted" dependencies we invite into our codebases every day.

In the world of modern software, trust is a vulnerability—don't let your next npm install be your last line of defence!`,
    },
    
   
  ];

  const [selectedStory, setSelectedStory] = useState({
    id: 0,
    img: "",
    date: "",
    storyTopic: "",
    storyContentShort: "",
    storyContent: "",
  });

  const handleModal = (value) => {
    setShow(true);
    setSelectedStory({
      id: value.id,
      img: value.img,
      date: value.date,
      storyTopic: value.storyTopic,
      storyContent: value.storyContent,
    });
  };

const formatStoryContent = (content) => {
  if (!content) return '';
  
 
  const sections = content.split(/\n\s*\n/);
  
  let formattedHtml = '';
  
  sections.forEach(section => {
    const trimmedSection = section.trim();
    if (!trimmedSection) return;
  
    const lines = trimmedSection.split('\n');
    const firstLine = lines[0];
    
   
    if (firstLine.endsWith(':') || 
        (firstLine.length < 50 && !firstLine.includes('.') && lines.length > 1)) {
   
      formattedHtml += `<h3>${escapeHtml(firstLine)}</h3>`;
     
      const remainingContent = lines.slice(1).join('\n').trim();
      if (remainingContent) {
        formattedHtml += `<p>${escapeHtml(remainingContent).replace(/\n/g, '<br/>')}</p>`;
      }
    } 
   
    else if (trimmedSection.includes('\n- ') || trimmedSection.includes('\n• ')) {
    
      const items = trimmedSection.split(/\n[-•]\s*/);
      const listTitle = items[0].trim();
      if (listTitle && !listTitle.match(/^[-•]/)) {
        formattedHtml += `<p>${escapeHtml(listTitle)}</p>`;
      }
      
      formattedHtml += `<ul>`;
      for (let i = 1; i < items.length; i++) {
        if (items[i].trim()) {
          formattedHtml += `<li>${escapeHtml(items[i].trim())}</li>`;
        }
      }
      formattedHtml += `</ul>`;
    }
    else {
   
      formattedHtml += `<p>${escapeHtml(trimmedSection).replace(/\n/g, '<br/>')}</p>`;
    }
  });
  
  return formattedHtml;
};


const escapeHtml = (text) => {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

  return (
    <>
      <div className="blog-area ptb-50" id="recentStory">
        <div className="container">
          <div className="section-title">
            <h2>Our Recent Story</h2>
            <div className="bar"></div>
            <p>Discover how we innovate, create, and transform businesses.</p>
          </div>
          <div className="row justify-content-center story">
            {storyArray.map((item) => (
              <div className="col-lg-6 col-md-12" key={item.id}>
                <div className="single-blog-post-box">
                  <div className="entry-thumbnail h-[700px]">
                    <img src={item.img} alt="Blog114" />
                  </div>
                  <div className="entry-post-content">
                   
                    <div className="entry-meta">
                  
                      <ul>
                        <li>Cyber Security</li>
                        <li>By Priyadharshini</li>
                        <li>{item.date}</li>
                      </ul>
               
                    </div>
                    
                    <h3>{item.storyTopic}</h3>
                    <p>{item.storyContentShort}</p>
                    <center>
                    <p
                      className="learn-more-btn"
                      onClick={() => handleModal(item)}
                    >
                      Read Story
                      <PiPlusBold className="fw-900 ms-1" />
                    </p>
                    </center>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="shape1">
          <img src={RoundShape} alt="shapegfgf" />
        </div>
        <div className="shape2 rotateme">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
            alt="shape"
          />
        </div>
        <div className="shape3">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
            alt="shape"
          />
        </div>
        <div className="shape4">
          <img
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
            alt="shape"
          />
        </div>
        <div className="shape7">
          <img
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
            alt="shape"
          />
        </div>
        <div className="shape8 rotateme">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
            alt="shape"
          />
        </div>
      </div>

 <Modal 
  show={show} 
  onHide={() => setShow(false)} 
  centered
  size="xl"
  dialogClassName="wide-modal"
>
  <div className="modal-content-custom">
    <Modal.Header closeButton className="modal-header-custom">
      {/* Optional: Add date or author here */}
    </Modal.Header>

    <Modal.Body className="modal-body-custom">
      <h4>{selectedStory.storyTopic}</h4>
      <div 
        className="story-content-wrapper"
        dangerouslySetInnerHTML={{ __html: formatStoryContent(selectedStory.storyContent) }}
      />
    </Modal.Body>
  </div>
</Modal>
    </>
  );
};

export default BlogPage;